import { cn } from "@/lib/cn";

const LOCATION_LABELS: Record<string, string> = {
  krasinskiego: "Krasińskiego",
  stanczyka: "Stańczyka",
  rydlowka: "Rydlówka",
};

const LOCATIONS = ["krasinskiego", "stanczyka", "rydlowka"] as const;

interface Props {
  value: string | null;   // null = all
  onChange: (loc: string | null) => void;
  showAll?: boolean;
}

export function LocationPicker({ value, onChange, showAll = true }: Props) {
  const options = showAll
    ? ([null, ...LOCATIONS] as (string | null)[])
    : ([...LOCATIONS] as (string | null)[]);

  return (
    <div className="flex items-center gap-0.5 rounded-md border border-border bg-bg p-0.5">
      {options.map((loc) => {
        const active = value === loc;
        const label = loc === null ? "Wszystkie" : (LOCATION_LABELS[loc] ?? loc);
        return (
          <button
            key={loc ?? "__all"}
            onClick={() => onChange(loc)}
            className={cn(
              "px-2.5 py-1 rounded text-xs font-medium transition-colors duration-150 whitespace-nowrap",
              active
                ? "bg-bg-elevated text-text shadow-sm border border-border"
                : "text-text-muted hover:text-text hover:bg-bg-subtle",
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
